var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/ClassifierService/removeChildFromAll.ts";
import "core-js/modules/es.array.reduce.js";
import { values } from 'ramda';
import { removeChild } from "./removeChild";
export function removeChildFromAll(nodes, child) {
  return values(nodes).reduce(function (acc, parentNode) {
    return parentNode ? removeChild(acc, parentNode.id, child) : acc;
  }, nodes);
}